import alertsContactsDriverObj from '@/shared/driverGuideForUsers/AlertContacts/alertContacts';
import policyDriverObj from '@/shared/driverGuideForUsers/alertServices/policy';
import toolsDriverObj from '@/shared/driverGuideForUsers/alertServices/tools';
import toolsMappingDriverObj from '@/shared/driverGuideForUsers/alertServices/toolsMapping';
import projectsMappingDriverObj from '@/shared/driverGuideForUsers/alertServices/projectMapping';
import assessmentDriverObj from '@/shared/driverGuideForUsers/assessments/assessmentMainPage';
import auditLogsDriverObj from '@/shared/driverGuideForUsers/AuditLogs/auditLog';
import companyDetailsDriverObj from '@/shared/driverGuideForUsers/company/companyDetails';
import usersDriverObj from '@/shared/driverGuideForUsers/companyUser/manageUsers';
import controlGroupDriverObj from '@/shared/driverGuideForUsers/controlGroupTemplate/controlGroupTemplate';
import diagramsDriverObj from '@/shared/driverGuideForUsers/documents/diagrams';
// import filesDriverObj from '@/shared/driverGuideForUsers/documents/files';
import filesDocumentsDriverObj from '@/shared/driverGuideForUsers/documents/filesDocuments';
import integrationsDriverObj from '@/shared/driverGuideForUsers/integration/integrations';
import allLogsDriverObj from '@/shared/driverGuideForUsers/logs/allLogs';
import manageNotificationDriverObj from '@/shared/driverGuideForUsers/ManageNotification';
import projectsDriverObj from '@/shared/driverGuideForUsers/projects/projects';
import stnServicesDriverObj from '@/shared/driverGuideForUsers/services/stnServices';
import allTicketsDriverObj from '@/shared/driverGuideForUsers/tickets/allTickets';
import createTicketsDriverObj from '@/shared/driverGuideForUsers/tickets/ticketsDriverConfig';
import timeEntriesDriverObj from '@/shared/driverGuideForUsers/timeEnteries/timeEnteries';
import allVmsDriverObj from '@/shared/driverGuideForUsers/VM/allVms';
import oneServerDriverObj from '@/shared/driverGuideForUsers/VM/oneServer';
import privateNetworkDriverObj from '@/shared/driverGuideForUsers/VM/privateNetworks';
import regionsDriverObj from '@/shared/driverGuideForUsers/VM/regions';
import vmDriverObj from '@/shared/driverGuideForUsers/VM/vm';
import vmDashboardDriverObj from '@/shared/driverGuideForUsers/VM/vmDashboard';
import vmTemplateDriverObj from '@/shared/driverGuideForUsers/VM/vmTemplate';
import vulnerabilitiesDriverObj from '@/shared/driverGuideForUsers/vulnerabilitiesScan/vulnerabilities';
import reportDriverPbj from '@/shared/driverGuideForUsers/MssReport/report';
import createPrivateNetworkDriverObj from '@/shared/driverGuideForUsers/VM/createPrivateNetwork';
import createVirtualMachineDriverObj from '@/shared/driverGuideForUsers/VM/createVm';
import rolesDriverObj from '@/shared/driverGuideForUsers/rbac/roles';
import teamsDriverObj from '@/shared/driverGuideForUsers/rbac/teams';
import modulesDriverObj from '@/shared/driverGuideForUsers/rbac/modules';
import permissionsDriverObj from '@/shared/driverGuideForUsers/rbac/permissions';
import resourcePermissionsDriverObj from '@/shared/driverGuideForUsers/rbac/resourcePermissions';
import createVmTemplateDriverObj from '@/shared/driverGuideForUsers/VM/createVmTemplate';
import createOneServerDriverObj from '@/shared/driverGuideForUsers/VM/createOneServer';
import { createRegionDriverObj } from '@/shared/driverGuideForUsers/VM/createRegion';
import roleCompaniesDriverObj from '@/shared/driverGuideForUsers/rbac/roleCompanies';
import roleCompanySitesDriverObj from '@/shared/driverGuideForUsers/rbac/roleCompanySites';
import attachSitesToRoleCompaniesDriverObj from '@/shared/driverGuideForUsers/rbac/attachSitesToRoleCompany';
import roleModulesDriverObj from '@/shared/driverGuideForUsers/rbac/roleModules';
import attachModulesToRoleDriverObj from '@/shared/driverGuideForUsers/rbac/attachModulesToRole';
import attachCompaniesToRoleDriverObj from '@/shared/driverGuideForUsers/rbac/attachCompaniesToRole';
import teamUsersDriverObj from '@/shared/driverGuideForUsers/rbac/teamUsers';
import addUsersInTeamDriverObj from '@/shared/driverGuideForUsers/rbac/addUsersInTeam';
import createTeamDriverObj from '@/shared/driverGuideForUsers/rbac/createTeam';
import createModuleDriverObj from '@/shared/driverGuideForUsers/rbac/createModule';
import { createPermissionsDriverObj } from '@/shared/driverGuideForUsers/rbac/createPermission';
import createResourcePermissionsDriverObj from '@/shared/driverGuideForUsers/rbac/createResourcePermissiom';
import K8DriverObj from '../../../shared/driverGuideForUsers/K8';
import VirtualGatewayDriverObj from '../../../shared/driverGuideForUsers/virtualGateway';
import inventoryDriverObj from '@/shared/driverGuideForUsers/inventoryManagement/inventory';
import transactionsDriverObj from '@/shared/driverGuideForUsers/inventoryManagement/transactions';
import ordersDriverObj from '@/shared/driverGuideForUsers/inventoryManagement/orders';
import reportsDriverObj from '@/shared/driverGuideForUsers/inventoryManagement/reports';

export const userGuideObj = {
  inventory_management: {
    inventory: inventoryDriverObj,
    orders: ordersDriverObj,
    transactions: transactionsDriverObj,
    reports: reportsDriverObj,
  },
  alert_contacts: alertsContactsDriverObj,
  alerts_policy: policyDriverObj,
  reports: reportDriverPbj,
  alerts_tools: toolsDriverObj,
  'alerts_services/tools_mapping': toolsMappingDriverObj,
  'alerts_services/tools_projects': projectsMappingDriverObj,
  assessments: assessmentDriverObj,
  audit_logs: auditLogsDriverObj,
  companymanagement: companyDetailsDriverObj,
  users: usersDriverObj,
  control_group_templates: controlGroupDriverObj,
  'documents/diagrams': diagramsDriverObj,
  'documents/files': filesDocumentsDriverObj,
  integrations: integrationsDriverObj,
  logs: allLogsDriverObj,
  manage_notifications: manageNotificationDriverObj,
  projects: projectsDriverObj,
  allprojects: projectsDriverObj,
  services: stnServicesDriverObj,
  alltickets: allTicketsDriverObj,
  tickets: createTicketsDriverObj,
  timeentries: timeEntriesDriverObj,
  all_virtual_machines: allVmsDriverObj,
  one_servers: oneServerDriverObj,
  private_networks: privateNetworkDriverObj,
  regions: regionsDriverObj,
  virtual_machines: vmDriverObj,
  virtual_machines_dashboard: vmDashboardDriverObj,
  vm_templates: vmTemplateDriverObj,
  vulnerability_scans: vulnerabilitiesDriverObj,
  'private_networks/create': createPrivateNetworkDriverObj,
  'virtual_machines/create': createVirtualMachineDriverObj,
  permissions_roles: rolesDriverObj,
  permissions_teams: teamsDriverObj,
  'permissions_teams/create': createTeamDriverObj,
  'permissions_teams/users': teamUsersDriverObj,
  'permissions_teams/users/addusers': addUsersInTeamDriverObj,
  dev_permission_modules: modulesDriverObj,
  'rbac/modules/create': createModuleDriverObj,
  'rbac/permissions': permissionsDriverObj,
  'rbac/permissions/create': createPermissionsDriverObj,
  'rbac/resourcepermissions': resourcePermissionsDriverObj,
  'rbac/resourcepermissions/create': createResourcePermissionsDriverObj,
  'permissions_roles/companies': roleCompaniesDriverObj,
  'permissions_roles/companies/attachcompanies': attachCompaniesToRoleDriverObj,
  'permissions_roles/companies/sites': roleCompanySitesDriverObj,
  'permissions_roles/companies/sites/attachsites': attachSitesToRoleCompaniesDriverObj,
  'permissions_roles/modules': roleModulesDriverObj,
  'permissions_roles/modules/attachmodules': attachModulesToRoleDriverObj,
  'vm_templates/add': createVmTemplateDriverObj,
  'one_servers/add': createOneServerDriverObj,
  'regions/add': createRegionDriverObj,
  kubernetes: K8DriverObj,
  virtual_gateway: VirtualGatewayDriverObj,
};

export const breadcrumbs = {
  '/permissions_roles/': 'Roles',
  '/permissions_roles/create/': 'Create Role',

  '/permissions_roles/scope/': 'Role Scope',
  // '/permissions_roles/modules/': 'Role Modules',
  // '/permissions_roles/companies/': 'Role Companies',
  // '/permissions_roles/sites/': 'Role Sites',
  '/permissions_roles/scope/sites/': 'Role Company Sites',
  // '/permissions_roles/companies/sites/': 'Role Company Sites',
  '/permissions_roles/scope/sites/attachsites/': 'Attach Sites to Company',
  // '/permissions_roles/companies/sites/attachsites/': 'Attach Sites to Company',
  '/permissions_roles/scope/attachsites/': 'Attach Sites to Role',
  // '/permissions_roles/sites/attachsites/': 'Attach Sites to Role',
  '/permissions_roles/scope/attachcompanies/': 'Attach Companies to Role',
  // '/permissions_roles/companies/attachcompanies/': 'Attach Companies to Role',
  '/permissions_roles/scope/attachmodules/': 'Attach Modules to Role',
  // '/permissions_roles/modules/attachmodules/': 'Attach Modules to Role',

  '/permissions_roles/edit/': 'Edit Role',
  '/permissions_roles/users/edituser/': 'Edit Role User',
  '/permissions_roles/roleassignment/': 'Role Assignment',
  '/permissions_roles/users/': 'Role Users',
  '/dev_permission_modules/': 'Modules',
  '/dev_permission_modules/create/': 'Create Module',
  '/dev_permission_type/': 'Permissions',
  '/dev_permission_resource/create/': 'Create Resource Permissions',
  '/dev_permission_resource/': 'Resource Permissions',
  '/dev_permission_type/create/': 'Create Permissions',
  '/permissions_teams/': 'Teams',
  '/permissions_teams/create/': 'Create Teams',
  '/permissions_teams/teamassignment/': 'Team Assignment',
  '/permissions_teams/users/': 'Teams Users',
  '/permissions_teams/users/addusers/': 'Add Users In Team',
  '/': 'Home',
  '/tickets/': 'Tickets',
  '/dashboard/': 'Dashboard',
  '/users/': 'Users',
  '/all_users/': 'All Users',
  '/all_users/profile/': 'Profile',
  '/users/profile/': 'Profile',
  '/profile/': 'Profile',
  '/projects/': 'Projects',
  '/allprojects/': 'All Projects',
  '/projects/detail/': 'Project Detail',
  '/projects/detail/subtask/': 'SubTask',
  '/tickets_dashboard': 'Tickets Dashboard',
  '/documents/files/': 'Document Storage',
  '/documents/diagrams/': 'Diagrams',
  '/documents/diagrams/detail': 'Diagram Detail',
  '/time_reporting/': 'Time Tracking',
  '/integrations/': 'Integrations',
  '/services/': 'Services',
  '/alltickets/': 'All Tickets',
  '/alltickets/detail/': 'Ticket Detail',
  '/company/': 'Company',
  '/companymanagement/': 'Company Management',
  '/companymanagement/:slug': '',
  '/reports/': 'Reports',
  '/audit_logs/': 'Audit Logs',
  '/logs/': 'All Logs',
  '/control_group_templates/': 'Control Group Templates',
  '/vulnerability_scans/create/': 'Create Vulnerability Scans',
  '/vulnerability_scans/': 'Vulnerability Scans',
  '/vulnerability_scans/multiplescans/': 'Multiple Vulnerability Scans',
  '/vulnerability_scans/multiplescans/detail/': ' Vulnerability Scan Details',
  '/privatenetworks/': 'Private Network',
  '/privatenetworks/create/': 'Create Private Network',
  '/privatenetworks/update/': 'Update Private Network',
  '/allprivatenetworks/': 'All Private Networks',
  '/assessments/vulnerability_scans/multiplescans/': 'Multiple Scans',
  '/assessments/vulnerability_scans/multiplescans/detail/': 'Vulnerability Scan Details',
  '/virtual_machines/': 'Virtual Machines',
  '/virtualmachinesdashboard/': 'Virtual Machines Dashboard',
  '/allvirtualmachines/': 'All Virtual Machines',
  '/allvirtualmachines/details/': 'Details',
  '/virtual_machines/create/': 'Create Virtual Machine',
  '/virtual_machines/edit/': 'Edit Virtual Machine ',
  '/vulnerability_scans/multiplescans/detail/edit/': 'Edit Scan',
  '/assessments/': 'Assessments',
  '/assessments/detail/': 'Assessment Details',
  '/manage_notifications/': 'Manage Notifications',
  '/alert_contacts/': 'Alert Contacts',
  '/contactUs/': 'Contact Us',
  '/vulnerability_scans/dashboard': 'Vulnerability Scans Dashboard',
  '/alerts_dashboard/': 'Alert Dashboard',
  '/alerts_policy/': 'Alerts Policy',
  '/alerts_tools/': 'Alerts Tools',
  '/alerts_services/enablealerts/': 'Enable Alerts',
  '/alerts_services/tools_mapping/': 'Tools Mapping',
  '/alerts_services/tools_projects/': 'Tools Project Mapping',
};

export const staticPermissions = {
  profile: '11111',
  contactUs: '11111',
};
